import React from 'react';

export default function Loader() {
  return (
    <div className="flex flex-col items-center space-y-2">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-blue-600 border-t-transparent"></div>
      <p className="text-gray-600 dark:text-gray-300">Analyzing audio, please wait…</p>
    </div>
  );
}
